import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminApi, formatApiErrorDetail } from "@/lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await adminApi.login(email.trim(), password);
      localStorage.setItem("twss_admin_token", res.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="flex min-h-screen items-center justify-center px-5 pt-24 pb-16"
    >
      <div className="w-full max-w-md rounded-3xl border border-corduroy bg-cocoa p-8 md:p-12">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/60 font-display text-lg font-black text-gold">
            S
          </span>
          <div className="leading-none">
            <p className="font-display text-base font-bold text-cream">THE BOOTH</p>
            <p className="font-editorial italic text-xs text-neon">studio access</p>
          </div>
        </div>
        <h1 className="mt-8 font-display text-3xl font-black tracking-tight text-cream md:text-4xl">
          Ashyla only beyond this point.
        </h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-latte">Email</span>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full rounded-xl border border-corduroy bg-ink px-4 py-3 text-sm text-cream outline-none transition-colors focus:border-gold"
              placeholder="you@thatswhatshisaid.com"
            />
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-latte">Password</span>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full rounded-xl border border-corduroy bg-ink px-4 py-3 text-sm text-cream outline-none transition-colors focus:border-gold"
              placeholder="••••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="rounded-xl border border-wine/50 bg-wine/15 px-4 py-3 text-sm text-cream">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-ember px-6 py-4 font-bold text-ink transition-colors hover:bg-neon hover:text-cream disabled:opacity-60"
          >
            {loading ? "Checking the list…" : "Enter the Booth"}
          </button>
        </form>
        <Link
          to="/"
          data-testid="admin-login-back-link"
          className="mt-6 block text-center text-xs text-latte transition-colors hover:text-gold"
        >
          &larr; Back to the show
        </Link>
      </div>
    </div>
  );
}
